(function () {
  if (window.ygbCardVariantList) return;
  window.ygbCardVariantList = true;

  var dragState = null;
  var resizeObserver = null;

  function listCanScroll(list) {
    return list.scrollWidth > list.clientWidth + 1;
  }

  function syncScroller(scroller) {
    var list = scroller.querySelector('.card-variant-list');
    if (!list) return;
    var max = list.scrollWidth - list.clientWidth;
    var canScroll = max > 1;
    var prev = scroller.querySelector('.card-variant-scroller__prev');
    var next = scroller.querySelector('.card-variant-scroller__next');
    scroller.classList.toggle('is-scrollable', canScroll);
    if (prev) {
      var prevDisabled = !canScroll || list.scrollLeft <= 1;
      prev.classList.toggle('is-disabled', prevDisabled);
      prev.disabled = prevDisabled;
    }
    if (next) {
      var nextDisabled = !canScroll || list.scrollLeft >= max - 1;
      next.classList.toggle('is-disabled', nextDisabled);
      next.disabled = nextDisabled;
    }
  }

  function bindScroller(scroller) {
    if (!scroller || scroller.dataset.bound === '1') return;
    var list = scroller.querySelector('.card-variant-list');
    if (!list) return;
    scroller.dataset.bound = '1';
    list.addEventListener('scroll', function () {
      syncScroller(scroller);
    }, { passive: true });
    if (resizeObserver) resizeObserver.observe(list);
    syncScroller(scroller);
  }

  /* body.is-card-color-menu のときだけカラーメニューを有効にする */
  function cardColorMenuActive() {
    return !!(document.body && document.body.classList.contains('is-card-color-menu'));
  }

  function scanScrollers(root) {
    if (!cardColorMenuActive()) return;
    var scope = root && root.querySelectorAll ? root : document;
    if (root && root.classList && root.classList.contains('card-variant-scroller')) bindScroller(root);
    var nodes = scope.querySelectorAll('.card-variant-scroller');
    for (var i = 0; i < nodes.length; i++) bindScroller(nodes[i]);
  }

  if (window.ResizeObserver) {
    resizeObserver = new ResizeObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var scroller = entries[i].target.closest('.card-variant-scroller');
        if (scroller) syncScroller(scroller);
      }
    });
  }

  scanScrollers(document);
  scanGalleries(document);
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType !== 1) continue;
          scanScrollers(added[j]);
          scanGalleries(added[j]);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Optimize Next が後から body にクラスを付けたときにメニューと画像列を有効化する */
  if (window.MutationObserver && document.body) {
    new MutationObserver(function () {
      if (!cardColorMenuActive()) return;
      scanScrollers(document);
      scanGalleries(document);
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'touch' || event.button !== 0) return;
    var list = event.target.closest('.card-variant-list');
    if (list && listCanScroll(list)) {
      dragState = {
        kind: 'list',
        list: list,
        pointerId: event.pointerId,
        startX: event.clientX,
        startScroll: list.scrollLeft,
        moved: false
      };
      return;
    }
    var track = event.target.closest('.card-variant-gallery__track');
    if (!track || track.scrollWidth <= track.clientWidth + 1) return;
    track.classList.add('is-pointer-down');
    track._dragging = true;
    dragState = {
      kind: 'gallery',
      track: track,
      pointerId: event.pointerId,
      startX: event.clientX,
      startScroll: track.scrollLeft,
      moved: false
    };
  });

  document.addEventListener('pointermove', function (event) {
    if (!dragState || event.pointerId !== dragState.pointerId) return;
    var dx = event.clientX - dragState.startX;
    if (!dragState.moved && Math.abs(dx) < 6) return;
    dragState.moved = true;
    if (dragState.kind === 'gallery') {
      dragState.track.classList.add('is-dragging');
      dragState.track._dragging = true;
      dragState.track.scrollLeft = dragState.startScroll - dx;
      return;
    }
    dragState.list.classList.add('is-dragging');
    dragState.list.scrollLeft = dragState.startScroll - dx;
  });

  function endDrag(event) {
    if (!dragState || event.pointerId !== dragState.pointerId) return;
    if (dragState.kind === 'gallery') {
      var track = dragState.track;
      var moved = dragState.moved;
      track.classList.remove('is-dragging');
      track.classList.remove('is-pointer-down');
      track._dragging = false;
      if (track._syncTimer) clearTimeout(track._syncTimer);
      if (moved) {
        track.dataset.suppressClick = '1';
        var index = galleryIndex(track);
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      }
      dragState = null;
      return;
    }
    var list = dragState.list;
    var listMoved = dragState.moved;
    list.classList.remove('is-dragging');
    if (listMoved) list.dataset.suppressClick = '1';
    dragState = null;
  }

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  // 画像スライドはリンクなので、標準のリンクドラッグがスクロールを奪う
  document.addEventListener('dragstart', function (event) {
    if (event.target.closest('.card-variant-gallery')) event.preventDefault();
  }, true);

  document.addEventListener('wheel', function (event) {
    var scroller = event.target.closest('.card-variant-scroller');
    var list = scroller
      ? scroller.querySelector('.card-variant-list')
      : event.target.closest('.card-variant-list');
    if (!list || !listCanScroll(list)) return;
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;

    var max = list.scrollWidth - list.clientWidth;
    var delta = event.deltaY;
    if (delta === 0) return;
    if (delta > 0 && list.scrollLeft >= max - 1) return;
    if (delta < 0 && list.scrollLeft <= 0) return;

    list.scrollLeft += delta;
    event.preventDefault();
  }, { passive: false });

  // カードごとに最後のホバーだけを反映する
  var hoverToken = typeof WeakMap === 'function' ? new WeakMap() : null;

  function nextHoverToken(card) {
    if (!hoverToken) return 0;
    var token = (hoverToken.get(card) || 0) + 1;
    hoverToken.set(card, token);
    return token;
  }

  function isCurrentHover(card, token) {
    if (!hoverToken) return true;
    return hoverToken.get(card) === token;
  }

  function galleryIndex(track) {
    var width = track.clientWidth;
    if (!width) return 0;
    var max = track.querySelectorAll('.card-variant-gallery__slide').length - 1;
    var index = Math.round(track.scrollLeft / width);
    if (index < 0) return 0;
    if (index > max) return max;
    return index;
  }

  function setCardLinks(card, url) {
    if (!url) return;
    var links = card.querySelectorAll('.card__heading a.full-unstyled-link');
    for (var i = 0; i < links.length; i++) links[i].setAttribute('href', url);
  }

  function clearChipSelection(card) {
    var chips = card.querySelectorAll('.card-variant-chip');
    for (var i = 0; i < chips.length; i++) {
      chips[i].classList.remove('is-selected');
      chips[i].setAttribute('aria-pressed', 'false');
    }
    card.classList.remove('is-variant-selected');
    setCardLinks(card, card.dataset.cardProductUrl);
  }

  function markChipSelected(chip) {
    var card = chip.closest('.card-wrapper');
    if (!card) return;
    var chips = card.querySelectorAll('.card-variant-chip');
    for (var i = 0; i < chips.length; i++) {
      var selected = chips[i] === chip;
      chips[i].classList.toggle('is-selected', selected);
      chips[i].setAttribute('aria-pressed', selected ? 'true' : 'false');
    }
    card.classList.add('is-variant-selected');
    setCardLinks(card, chip.getAttribute('data-variant-url'));
  }

  function revealChip(chip) {
    var list = chip.closest('.card-variant-list');
    var item = chip.closest('.card-variant-list__item');
    if (!list || !item) return;
    var target = item.offsetLeft - (list.clientWidth - item.offsetWidth) / 2;
    var max = list.scrollWidth - list.clientWidth;
    if (target < 0) target = 0;
    if (target > max) target = max;
    list.scrollTo({ left: target, behavior: 'smooth' });
  }

  // 必要なスライドだけ src を入れる。初期 HTML ではメイン画像以外を読まない
  function loadSlideImage(img) {
    if (!img || img.getAttribute('src')) return;
    var src = img.getAttribute('data-src');
    if (!src) return;
    img.removeAttribute('loading');
    img.setAttribute('src', src);
  }

  function preloadAround(track, index) {
    var slides = track.querySelectorAll('.card-variant-gallery__slide');
    for (var i = index - 1; i <= index + 1; i++) {
      if (!slides[i]) continue;
      loadSlideImage(slides[i].querySelector('img[data-src]'));
    }
  }

  function hidePreview(card) {
    if (!card) return;
    nextHoverToken(card);
    var preview = card.querySelector('.card-variant-gallery__preview');
    if (preview) preview.classList.remove('is-visible');
  }

  function showPreview(card, url) {
    var preview = card.querySelector('.card-variant-gallery__preview');
    if (!preview || !url) return;
    var token = nextHoverToken(card);
    var loader = new Image();
    loader.onload = function () {
      if (!isCurrentHover(card, token)) return;
      preview.setAttribute('src', url);
      preview.classList.add('is-visible');
    };
    loader.src = url;
    if (loader.complete && loader.naturalWidth) loader.onload();
  }

  function syncGallerySelection(track) {
    var card = track.closest('.card-wrapper');
    if (!card || track._dragging) return;
    var index = galleryIndex(track);
    preloadAround(track, index);
    if (track._hidePreviewToken != null) {
      if (isCurrentHover(card, track._hidePreviewToken)) {
        var preview = card.querySelector('.card-variant-gallery__preview');
        if (preview) preview.classList.remove('is-visible');
      }
      track._hidePreviewToken = null;
    }
    if (index === 0) {
      clearChipSelection(card);
      return;
    }
    var chip = card.querySelector('.card-variant-chip[data-slide-index="' + index + '"]');
    if (!chip) return;
    markChipSelected(chip);
    revealChip(chip);
  }

  function scheduleGallerySync(track) {
    if (track._syncTimer) clearTimeout(track._syncTimer);
    track._syncTimer = setTimeout(function () {
      syncGallerySelection(track);
    }, 80);
  }

  function scrollGalleryTo(track, index) {
    preloadAround(track, index);
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = index * track.clientWidth;
    track.style.scrollBehavior = '';
  }

  function mountGallery(card) {
    if (!card || card.dataset.galleryBound === '1') return;
    var media = card.querySelector('.card__media .media');
    var mainImg = media && media.querySelector('img.js-card-variant-image');
    if (!mainImg) return;
    var chips = card.querySelectorAll('.card-variant-chip[data-image-url]');
    if (!chips.length) return;
    card.dataset.galleryBound = '1';

    var heading = card.querySelector('.card__heading a.full-unstyled-link');
    if (heading) card.dataset.cardProductUrl = heading.getAttribute('href');

    var gallery = document.createElement('div');
    gallery.className = 'card-variant-gallery';
    var track = document.createElement('div');
    track.className = 'card-variant-gallery__track';

    var productUrl = card.dataset.cardProductUrl || '#';
    var first = document.createElement('a');
    first.className = 'card-variant-gallery__slide';
    first.dataset.slideIndex = '0';
    first.href = productUrl;
    first.draggable = false;
    first.tabIndex = -1;
    mainImg.setAttribute('draggable', 'false');
    first.appendChild(mainImg);
    track.appendChild(first);

    for (var i = 0; i < chips.length; i++) {
      var chip = chips[i];
      var slideIndex = String(i + 1);
      chip.setAttribute('data-slide-index', slideIndex);
      var slide = document.createElement('a');
      slide.className = 'card-variant-gallery__slide';
      slide.dataset.slideIndex = slideIndex;
      slide.href = chip.getAttribute('data-variant-url') || productUrl;
      slide.draggable = false;
      slide.tabIndex = -1;
      var img = document.createElement('img');
      img.className = 'motion-reduce';
      img.alt = chip.getAttribute('data-image-alt') || '';
      img.setAttribute('loading', 'lazy');
      img.setAttribute('data-src', chip.getAttribute('data-image-url'));
      img.setAttribute('draggable', 'false');
      img.width = 360;
      img.height = 360;
      slide.appendChild(img);
      track.appendChild(slide);
    }

    var preview = document.createElement('img');
    preview.className = 'card-variant-gallery__preview motion-reduce';
    preview.alt = '';
    preview.setAttribute('aria-hidden', 'true');

    gallery.appendChild(track);
    gallery.appendChild(preview);
    media.appendChild(gallery);

    track.addEventListener('scroll', function () {
      scheduleGallerySync(track);
    }, { passive: true });
    track.addEventListener('touchstart', function (event) {
      track._touchX = event.touches[0].clientX;
      track._touchMoved = false;
    }, { passive: true });
    track.addEventListener('touchmove', function (event) {
      if (Math.abs(event.touches[0].clientX - track._touchX) > 6) track._touchMoved = true;
    }, { passive: true });
  }

  function scanGalleries(root) {
    if (!cardColorMenuActive()) return;
    var scope = root && root.querySelectorAll ? root : document;
    if (root && root.classList && root.classList.contains('card-wrapper')) mountGallery(root);
    var cards = scope.querySelectorAll('.card-wrapper');
    for (var i = 0; i < cards.length; i++) mountGallery(cards[i]);
  }

  // クリックでスライドをその色へ動かす。ホバーでは動かさない
  function applyChip(chip) {
    var card = chip.closest('.card-wrapper');
    if (!card) return;
    var imageUrl = chip.getAttribute('data-image-url');
    var preview = card.querySelector('.card-variant-gallery__preview');
    var previewMatches = preview
      && preview.classList.contains('is-visible')
      && preview.getAttribute('src') === imageUrl;
    if (!previewMatches) hidePreview(card);
    markChipSelected(chip);

    var slideIndex = chip.getAttribute('data-slide-index');
    if (!slideIndex) return;
    var track = card.querySelector('.card-variant-gallery__track');
    if (!track) return;
    if (previewMatches) track._hidePreviewToken = hoverToken ? (hoverToken.get(card) || 0) : 0;
    scrollGalleryTo(track, Number(slideIndex));
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    if (dragState) return;
    var chip = event.target.closest('.card-variant-chip');
    if (!chip) return;
    if (event.relatedTarget && chip.contains(event.relatedTarget)) return;
    var card = chip.closest('.card-wrapper');
    if (!card) return;
    var imageUrl = chip.getAttribute('data-image-url');
    if (!imageUrl) {
      hidePreview(card);
      return;
    }
    var slideIndex = chip.getAttribute('data-slide-index');
    if (slideIndex) {
      var slide = card.querySelector('.card-variant-gallery__slide[data-slide-index="' + slideIndex + '"] img');
      loadSlideImage(slide);
    }
    showPreview(card, imageUrl);
  });

  document.addEventListener('pointerout', function (event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    var chip = event.target.closest('.card-variant-chip');
    if (!chip) return;
    if (event.relatedTarget && chip.contains(event.relatedTarget)) return;
    var card = chip.closest('.card-wrapper');
    var nextChip = event.relatedTarget && event.relatedTarget.closest
      ? event.relatedTarget.closest('.card-variant-chip')
      : null;
    if (nextChip && card && nextChip.closest('.card-wrapper') === card) return;
    hidePreview(card);
  });

  document.addEventListener('click', function (event) {
    var gallerySlide = event.target.closest('.card-variant-gallery__slide');
    if (gallerySlide) {
      var galleryTrack = gallerySlide.closest('.card-variant-gallery__track');
      if (galleryTrack && (galleryTrack.dataset.suppressClick === '1' || galleryTrack._touchMoved)) {
        delete galleryTrack.dataset.suppressClick;
        galleryTrack._touchMoved = false;
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    }

    var nav = event.target.closest('.card-variant-scroller__prev, .card-variant-scroller__next');
    if (nav) {
      event.preventDefault();
      event.stopPropagation();
      if (nav.disabled) return;
      var navScroller = nav.closest('.card-variant-scroller');
      var navList = navScroller && navScroller.querySelector('.card-variant-list');
      if (!navList) return;
      var direction = nav.classList.contains('card-variant-scroller__next') ? 1 : -1;
      var step = Math.max(navList.clientWidth - 28, 32);
      navList.scrollBy({ left: direction * step, behavior: 'smooth' });
      return;
    }

    var list = event.target.closest('.card-variant-list');
    if (list && list.dataset.suppressClick === '1') {
      delete list.dataset.suppressClick;
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    var chip = event.target.closest('.card-variant-chip');
    if (!chip) return;

    event.preventDefault();
    event.stopPropagation();
    applyChip(chip);
  });
})();
